// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"00bb4630","952":"9cc16679"}[chunkId] + ".chunk.js";
};